import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Colorize from "@material-ui/icons/Colorize";
import { PRESET_COLORS, normalizeHexColor } from "../../helpers/colorPalette";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gap: theme.spacing(1.25),
    width: "100%",
    minWidth: 0,
  },
  swatches: {
    display: "grid",
    gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
    gap: 8,
    justifyItems: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
    },
  },
  swatch: {
    appearance: "none",
    WebkitAppearance: "none",
    display: "block",
    width: 32,
    height: 32,
    minWidth: 32,
    minHeight: 32,
    maxWidth: 32,
    maxHeight: 32,
    padding: 0,
    margin: 0,
    lineHeight: 0,
    fontSize: 0,
    borderRadius: "50%",
    border: `2px solid ${theme.mode === "dark" ? "#334155" : "#e5e8f0"}`,
    cursor: "pointer",
    boxSizing: "border-box",
    flexShrink: 0,
    aspectRatio: "1 / 1",
    outline: "none",
  },
  swatchActive: {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}33`,
  },
  preview: {
    width: 18,
    height: 18,
    borderRadius: "50%",
    border: `1px solid ${theme.mode === "dark" ? "#4B5563" : "#e0e0e0"}`,
  },
}));

const ColorPaletteField = ({
  value,
  onChange,
  label = "Color",
  error,
  helperText,
  colors = PRESET_COLORS,
}) => {
  const classes = useStyles();
  const current = normalizeHexColor(value);
  const [hexInput, setHexInput] = useState(current);

  useEffect(() => {
    setHexInput(current);
  }, [current]);

  const commitHex = () => {
    onChange(normalizeHexColor(hexInput, current));
  };

  return (
    <div className={classes.root}>
      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        label={label}
        value={hexInput}
        onChange={(event) => setHexInput(event.target.value)}
        onBlur={commitHex}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            commitHex();
          }
        }}
        error={Boolean(error)}
        helperText={helperText}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Colorize fontSize="small" color="action" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <span className={classes.preview} style={{ backgroundColor: current }} />
            </InputAdornment>
          ),
        }}
      />
      <div className={classes.swatches}>
        {colors.map((color) => (
          <button
            key={color}
            type="button"
            aria-label={color}
            className={`${classes.swatch} ${
              current.toLowerCase() === color.toLowerCase() ? classes.swatchActive : ""
            }`}
            style={{ backgroundColor: color }}
            onClick={() => onChange(color)}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPaletteField;
